import { createSelector } from 'reselect';
import {
  getSelectedProductDetails,
} from '@americanexpress/product-ducks';
import { RootStateOrAny } from 'react-redux';

const getLocale = (state: RootStateOrAny): string => state.getIn(['intl', 'activeLocale']);
const getIsSupportedMarket = createSelector(
  [getLocale],
  (locale): boolean => locale === 'en-US'
);

const getConfig = (state: RootStateOrAny): ReadonlyMap<string, string> => state.getIn(['config']);
const getRootModuleName = createSelector(
  [getConfig],
  (config): string | undefined => config.get('rootModuleName')
);

const emptyRoles: string[] = [];
const getUserRoles = createSelector(
  [getSelectedProductDetails],
  (productDetails): string[] => {
    if (productDetails && 'authorized_user_profile' in productDetails) {
      return productDetails?.authorized_user_profile?.roles || emptyRoles;
    }
    return emptyRoles;
  }
);

export {
  getLocale,
  getIsSupportedMarket,
  getRootModuleName,
  getUserRoles,
};
